"use client";

import { useRef } from "react";
import { motion, useInView } from "framer-motion";
import { useNavigate } from "react-router-dom";

const TryNow = () => {
  const sectionRef = useRef(null);
  const textRef = useRef(null);
  const buttonRef = useRef(null);
  const svgRef = useRef(null);

  const navigate = useNavigate();

  const handleNavigate = () => {
    navigate("/register");
  };

  const isTextInView = useInView(textRef, { once: true, amount: 0.5 });
  const isButtonInView = useInView(buttonRef, { once: true, amount: 0.5 });
  const isSvgInView = useInView(svgRef, { once: true, amount: 0.3 });

  return (
    <section
      ref={sectionRef}
      className="relative w-full py-16 md:py-24 overflow-hidden bg-red-50"
    >
      {/* Background pattern */}
      <motion.div
        ref={svgRef}
        className="absolute inset-0 w-full h-full"
        initial={{ opacity: 0, scale: 0.8 }}
        animate={
          isSvgInView ? { opacity: 1, scale: 1 } : { opacity: 0, scale: 0.8 }
        }
        transition={{ duration: 1.2, ease: "easeOut" }}
      >
        <svg
          className="absolute top-0 left-0 w-full h-full opacity-10"
          viewBox="0 0 800 800"
          xmlns="http://www.w3.org/2000/svg"
        >
          <circle
            cx="400"
            cy="400"
            r="380"
            fill="none"
            stroke="#EF4444"
            strokeWidth="2"
          />
          <circle
            cx="400"
            cy="400"
            r="300"
            fill="none"
            stroke="#DC2626"
            strokeWidth="2"
          />
          <circle
            cx="400"
            cy="400"
            r="220"
            fill="none"
            stroke="#B91C1C"
            strokeWidth="2"
          />
          <circle
            cx="400"
            cy="400"
            r="140"
            fill="none"
            stroke="#991B1B"
            strokeWidth="2"
          />
        </svg>
      </motion.div>

      {/* Content container */}
      <div className="container relative mx-auto px-4 md:px-6">
        <div className="flex flex-col md:flex-row items-center justify-between">
          {/* Left side - Text content */}
          <motion.div
            ref={textRef}
            className="mb-8 md:mb-0"
            initial={{ opacity: 0, y: 50 }}
            animate={
              isTextInView ? { opacity: 1, y: 0 } : { opacity: 0, y: 50 }
            }
            transition={{ duration: 0.8, ease: "easeOut" }}
          >
            <p className="text-red-600 font-medium mb-2">Try Vaspay Now</p>
            <h2 className="text-3xl md:text-4xl lg:text-5xl font-bold text-red-900 max-w-xl">
              Start accepting payments in just 30 minutes
            </h2>
          </motion.div>

          {/* Right side - CTA button */}
          <motion.div
            ref={buttonRef}
            initial={{ opacity: 0, y: 30 }}
            animate={
              isButtonInView ? { opacity: 1, y: 0 } : { opacity: 0, y: 30 }
            }
            transition={{ duration: 0.6, ease: "easeOut", delay: 0.3 }}
          >
            <button
              className="bg-red-500 hover:bg-red-600 transition-colors duration-300 text-white font-medium rounded-lg px-6 py-3 text-lg shadow-sm"
              onClick={handleNavigate}
            >
              Create a free account
            </button>
          </motion.div>
        </div>
      </div>
    </section>
  );
};

export default TryNow;
